import React from 'react';

const BottomWarningBar: React.FC = () => {
  return (
    <div
      style={{
        width: '100%',
        height: '30px',
        backgroundColor: 'black',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: 'white',
        fontWeight: 'bold'
      }}
    >
      Koru AI can make mistakes. Please make sure to check important info.
    </div>
  );
};

export default BottomWarningBar;
